
<app-navbartwo></app-navbartwo>
<section class="banner_image1">
  <video  id="myVideo"  #video (canplay)="video.play()" autoplay muted loop
  (loadedmetadata)="video.muted = true" class="home_video">
    <source src="../../assets/images/video_two.mp4" type="video/mp4">
    Your browser does not support HTML5 video.
  </video>
  <script>
    var video = document.getElementById("myVideo");
    var btn = document.getElementById("myBtn");

    function myFunction() {
      if (video.paused) {
        video.play();
        btn.innerHTML = "Pause";
      } else {
        video.pause();
        btn.innerHTML = "Play";
      }
    }
    </script>
  <!-- <video #video (canplay)="video.play()" autoplay muted loop id="myVideo" >
    <source src="../../assets/images/video_two.mp4" type="video/mp4">
    Your browser does not support HTML5 video.
  </video>
  <script>
  var video = document.getElementById("myVideo");
  var btn = document.getElementById("myBtn");

  function myFunction() {
    if (video.paused) {
      video.play();
      btn.innerHTML = "Pause";
    } else {
      video.pause();
      btn.innerHTML = "Play";
    }
  }
  </script> -->
</section>
<!-- <section class="section-one-bg">
  <div class="container">

    <div class="row">
      <div class="col-md-5">
        <div class="banner_right">
        <h5 class="banner_text_main">Powerful Product<br>
        Presentations</h5>
         <p class="section_top">
          Eye-catching WordPress themes customised and curated for
           single product presentation shops.
         </p>
         <br>
         <button class="demo_button"><a style="color:black">Get a free Demo</a></button>
         </div>
      </div>
      <div class="col-md-7">
        <div>
          <img src="../../assets/images/banner_image_1.png" alt="video_image" class="video_image">
        </div>
    </div>
    </div>

  </div>
</section> -->
<!-- section of the page in header section2 End -->
<section style="background-color: white;background-image: url(../../assets/images/kid_bg.png);">
  <div class="container">
    <h4 class="h4_heading" style="margin-top: 0%;">MCred Pro - The Divergent Tenet
      <br>
      <img src="../../../assets/images/mtac_new10.png" alt="undrline"/>
    <!-- <div class="dottedline3">
    </div><span class="dot3"></span> -->
    </h4>
    <div class="row">
      <img src="../../../assets/images/animation2_right_s3.png" alt="animation2_right" class="animation2_right">
      <div class="col-md-7 order-2 order-lg-1 ">
        <img src="../../assets/images/laptop_image_section.png" alt="section2_image" class="lappiimage_main"/>
      </div>
      <div class="col-md-5  order-1 order-lg-2 section3_maintext">
         <p class="sectionp sectionpext">
          In the ever changing social and retail milieu of today's fast-paced, insta-tech next gen millennials,
          MCred brings easy click access to the forefront. From conceptualization to completion, we will take
           care of it all. Be it an online venture that you are passionate about or a business you want to put online,
           MCred is the right place!<br>
        <br>
        Will be there through it all to ensure that your thoughts and ideas see the light of day and your
        business reflects exactly what you want. Be it design, user ease, security features, we will deliver it,
         while making it trendy, compatible and functional. Our dedicated and passionate team will help deliver
         what is needed, when it is needed.
         </p>
     </div>
   </div>
  </div>
</section>

<!-- section of the page in header section6  -->
<section>
        <div class="row" style="background-color: #fff;">
          <div class="col-md-6 section3_maintext">
            <div class="differencres_section">
              <h4 class="h4_heading" style="text-align: left;">The MCred Difference
              </h4>
               <p class="sectionp">
                What sets MCred apart? Well, the MCred difference is the whole difference, which sets us apart from
                the regular run-of-the-mill platforms. Our e-commerce platforms are beyond customized themes and needs,
                they take the UI a notch further up to enhance the customer's online access. With cutting-edge
                e-commerce tools, an adept support team to accentuate and handle your every need, our difference
                makes the whole difference!
                  <br>
                 <br>
                In tunes with the current scenarios, our themes are totally mobile friendly and customized to
                suit your requirement. Of course, it comes with a powerful combination of the latest tools and
                low-friction functionality. Be ahead of the rest with our state-of-the-art tools and an equally
                proficient team to handle it efficiently.
               </p>
            </div>
         </div>
         <div class="col-md-6 reviews_imagebg">
          <img src="../../../assets/images/apple_imagecontent.png" alt="section2_image" class="section2sets_image"/>
        </div>
       </div>
</section>
<!-- section of the page in header section6  End-->

<!-- section of the page in header section8  -->
<section style="background-color:#fff;" >
  <h4 class="explore_more_h4" style="font-size: 22px;margin-top: 0%;padding-top:40px;">Explore More<br>
    <img src="../../../assets/images/mtac_new10.png" alt="undrline"/>
  </h4><br>
</section>
<section style="background-color: rgb(46, 46, 46); padding-top: 40px;">
  <div class="container">
      <div class="planning_topdiv">
      <div class="row">
        <div class="col-md-4 col-lg-2 boxshadesh active">
           <div class="explore_box sideline_section">
            <img src="../../../assets/images/wexplore1.png" alt="explore_image1" class="explore_image1 explore_image11">
            <h5 class="explore_h5">Product cart</h5>
          </div>
           <div class="hide_section">
           <p class="explore_p explore_p1">Make them more visible for an unforgettable shopping experience with seamless ease. </p>
           </div>
          </div>
        <div class="col-md-4 col-lg-2 boxshadesh active">
          <div class="explore_box sideline_section">
            <!-- <i class="explore_image2 explore_image12"></i> -->
            <img src="../../../assets/images/wexplore3.png" alt="explore_image1" class="explore_image2 explore_image12">
            <h5 class="explore_h5">Adaptable Workflow</h5>
          </div>
           <div class="hide_section">
          <p class="explore_p explore_p2">With topmost priority given to performance, it is designed to be totally
             in sync with your needs. </p>
             </div>
        </div>
        <div class="col-md-4 col-lg-2 boxshadesh">
          <div class="explore_box sideline_section">
            <img src="../../../assets/images/wexplore2.png" alt="explore_image1" class="explore_image3 explore_image13">
            <h5 class="explore_h5">In Vogue</h5>
          </div>
           <div class="hide_section">
          <p class="explore_p explore_p3">Setting a trend, that is not just aesthetically great but
            functionally compatible too for every need.
          </p>
          </div>
        </div>
        <div class="col-md-4 col-lg-2 boxshadesh">
           <div class="explore_box sideline_section">
            <img src="../../../assets/images/wexplore6.png" alt="explore_image1" class="explore_image1 explore_image14">
            <h5 class="explore_h5">Trustworthy Support</h5>
          </div>
           <div class="hide_section">
            <p class="explore_p explore_p4">When we say support, we mean it and we have got you covered. We offer
               dedicated commercial support.
            </p>
            <!--When we say support, we mean it and we have got you covered. We offer free community or
               dedicated commercial support.-->
           </div>
        </div>
        <div class="col-md-4 col-lg-2 boxshadesh">
          <div class="explore_box sideline_section">
            <img src="../../../assets/images/wexplore5.png" alt="explore_image1" class="explore_image2 explore_image15">
            <h5 class="explore_h5">Gain More Visibility</h5>
          </div>
           <div class="hide_section">
          <p class="explore_p explore_p5">More visibility means more business. Turn your existing retail store online and increase
            your customer base.
          </p>
          <!--More visibility means more business. Turn your existing retail store online and increase
            your customer base exponentially.-->
          </div>
        </div>
        <div class="col-md-4 col-lg-2 boxshadesh">
          <div class="explore_box sideline_section">
            <img src="../../../assets/images/wexplore4.png" alt="explore_image1" class="explore_image3 explore_image16">
            <h5 class="explore_h5">Get Online</h5>
          </div>
           <div class="hide_section">
          <p class="explore_p explore_p6">Got a great idea for a trendy business?! Get online and learn about a new way to make money.
          </p>
        </div>
        </div>
      </div>
      </div>
  </div>
</section>
<!-- section of the page in header section8  End-->
<!-- section of the page in header section3  -->
<section style="background-color: white;
padding: 5px;">
 <div class="container">
    <div class="row" style="margin-top:45px;">
     <h4 class="features_heading">Dynamic Frontiers of Commerce<br>
     <img src="../../../assets/images/mtac_new10.png" alt="undrline"/>
   </h4>
    </div>
    <p class="psection_two">
      The world wide web has not just revolutionized the business landscapes but also turned
       the growing e-commerce frontiers into a boon that we cannot do without. Customer-oriented
       strategies, efficient and user-friendly modules et al are now the need of the hour. With
       increasing purchasing power and varied options, being unique is quite essential and necessary.
   </p>
   </div>

</section>
<!-- section of the page in header section3 End -->
<!-- section of the page in header section4 -->
<section class="reviews_imagebg">
  <div class="">
    <div class="row section_2_boxdiv">
        <div class="col-md-4">
           <div  class="main_box_blocks">
             <div class="inner_border">
              <img src="../../../assets/images/s3img1.png" alt="inner_image" class="innerimage">
                <div>
                  <h6 class="bolck_6h">The Internet Influence</h6>
                  <p class="main_box_blocksp">
                    It the influence that cannot be ignored and has to be seen: Personalized Commerce,
                    Interactive Product Visuals and Social Commerce.<!--Through Celebrity Endorsements to
                     name a few among many others.-->
                  </p>
                </div>
             </div>
           </div>
        </div>
        <div class="col-md-4">
          <div  class="main_box_blocks">
            <div class="inner_border">
                <img src="../../../assets/images/s3img2.png" alt="inner_image" class="innerimage">
              <div>
                <h6 class="bolck_6h">The Trends of 21st Century</h6>

                <p class="main_box_blocksp">
                  Be in tune with the latest trends of the year; be it the emerging ones that are gathering
                   attention or the ones catching the spotlight.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="main_box_blocks">
            <div class="inner_border">
              <img src="../../../assets/images/s3img3.png" alt="inner_image" class="innerimage">
              <div>
                <h6 class="bolck_6h">Brighter Future</h6>

                <p class="main_box_blocksp">
                  Smaller companies with well-executed ideas garner a larger market share. With advances in
                  cloud-based solutions they can scale quickly.<!-- without investing a fortune.-->
                </p>
              </div>
            </div>
          </div>
        </div>
    </div>

  </div>
</section>
<!-- section of the page in header section4 End -->

<!-- section of the page in header section8  -->
<section class="section_white_bg">
  <div class="container">
    <div class="message_box" >
      <div class="row">
        <div class="planning_topdivss">
        <h4 class="h4_heading" style="color:#fff;padding-top:18px;">Online is the place to be! MCred is the one to be with! Get online now, with us!

        </h4>
        <button class="getstarted_button">Get Started</button>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- section of the page in header section8  End-->
<section class="index-link">
  <div class="container">
      <div class="row footer_gap">
          <div class="col-md-5 col-lg-5 footer_section1">
              <div class="link-area">
                <div>
                  <a href="index.html"> <img src="../../../assets/images/Final_Logo-01.png" alt="footerlogo" class="footer_logo"/>
                   </a>
                  <p style="color: black;">Take actions that make an impact. Providing services
                    <br> for all to grow and prosper.</p>
                </div>
              </div>
          </div>
          <div class="col-md-5 col-lg-4 footer_section2">
              <div class="link-area">
                <p>
                  <i class="fa fa-envelope mr-3" style="color:#fc0e40;font-size: 15px;"></i>
                  <a href="https://mail.google.com/mail/u/0/?view=cm&fs=1&tf=1&source=mailto&su=Hi+There&to=info@manteio.in&body=body+goes+here" target="_blank" style="color:black;">
                  connect@manteio.in</a>
              </p>
              <p>
                  <i class="fa fa-phone mr-3" style="color:#fc0e40;transform: rotate(0deg);font-size: 20px;"></i>
                  <a href="tel:+919391385170" style="color: black;">+91 9391385170</a>
              </p>
              <p style="color: black;">
                  <i class="fa fa-map-marker mr-3" style="color:#fc0e40;font-size: 20px;"></i>
                  <span style="margin-left: 5px;color: black;
                  margin-top: -14px;">The Platina, B-605</span>
              </p><p class="contact_address_footer"> Gachibowli, Telangana 500032<br>
</p>



              </div>
          </div>
          <div class="col-md-6 col-lg-3 footer_section3">
            <div class="link-area">
                <h5 style="color: black;font-size: 18px;">Powered by</h5>
                <div class="manteiologo">
                    <a href="#">
                    <img src="../../assets/images/manteio_b.png" alt="manteiologo" style="width: 100%;"/>
                    </a>
                </div>
                <p>
                  <a href="https://www.facebook.com/manteioIT/" class="sicons" target="_blank">
                    <span class="icon social">  <i class="fa fa-facebook" aria-hidden="true"></i></span>
                  </a>
                  <a href="https://www.twitter.com/manteioIT" class="sicons" target="_blank">
                     <span class="icon social"><i class="fa fa-twitter"></i></span>
                  </a>
                  <a href="https://www.linkedin.com/company/manteiotechnologies" class="sicons" target="_blank">
                    <span class="icon social">  <i class="fa fa-linkedin-square" aria-hidden="true"></i></span>
                  </a>
                  <a href="https://www.instagram.com/manteio_it_solutions" class="sicons" target="_blank">
                    <span class="icon social">  <i class="fa fa-instagram" aria-hidden="true"></i></span>
                  </a>

              </p>
            </div>
        </div>

      </div>
  </div>
</section>
<section style="background-color: #282729;padding-top:10px;padding-bottom: 10px;">
  <div class="container">
         <!-- Copyright -->
   <div class="footer-copyright">
    <div class="sectionmargin">
      <div class="row">
        <div class="col-md-4">

        </div>
        <div class="col-md-5">
          <p class="rightsreserved" style="margin-bottom: 0rem;"><a href="#" style="color: #fff;"> ©2023 Copyright - All Rights Reserved</a></p>
        </div>
        <div class="col-md-3">

        </div>
      </div>
    </div>
  </div>
  </div>
</section>

